// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"349":"807545f5","648":"807545f5"}[chunkId] + ".css";
};